import {ChangeDetectionStrategy, Component, inject} from '@angular/core';
import {CatalogSelectors} from '@store/catalog/catalog.selectors';
import {SelectPipe} from '@aviary/pipes/select.pipe';
import {CatalogRecord} from '@store/catalog/catalog.types';
import {Store} from '@ngrx/store';
import {CatalogActions} from '@store/catalog/catalog.actions';
import {TruncateDirective} from '@aviary/directives/truncate.directive';
import {MatCard, MatCardContent, MatCardTitle} from '@angular/material/card';
import {CoverImageGridComponent} from '@lib/components/cover-image-grid/cover-image-grid.component';
import {PaginationComponent} from '@aviary/components/table/pagination/pagination.component';
import {IconButtonComponent} from '@aviary/buttons/icon-button/icon-button.component';
import {HoldIconButtonComponent} from '@app/my-account/holds/hold-actions/hold-icon-button/hold-icon-button.component';
import {HoldsSelectors} from '@store/holds/holds.selectors';
import {HiddenUntilLoadedDirective} from '@aviary/directives/hidden-until-loaded.directive';

@Component({
  selector: 'px-favorites',
  templateUrl: './favorites.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    SelectPipe, CoverImageGridComponent, TruncateDirective, MatCardTitle, MatCard, MatCardContent, PaginationComponent, IconButtonComponent,
    HoldIconButtonComponent, HiddenUntilLoadedDirective
  ]
})
export class FavoritesComponent {
  private readonly store: Store = inject(Store);
  public readonly favoritesSelectors = CatalogSelectors.Favorites;
  public readonly statelessSelectors = CatalogSelectors.Stateless;
  public readonly holdSelectors = HoldsSelectors.HoldsForCatalogRecords;

  public removeFromFavorites(favorite: CatalogRecord) {
    this.store.dispatch(CatalogActions.showRemoveFavorite(favorite));
  }
}
